<template>
  <el-form class="reports-index">
    <h3>Наряды</h3>
    <div class="create-new">
      <router-link :to="`/dashboard/workorders-reports/create`" class="add-block">
        <el-button type="primary"> + Создать</el-button>
      </router-link>
    </div>
    <div class="search-filter">
      <div class="text-search-container">
        <el-input placeholder="Номер" class="input-search number-search" v-model="search" style="margin-right: 8px">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>

        <el-input placeholder="Заголовок наряда" v-model="searchHead" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="filter-worker">
        <!--        <el-popover-->
        <!--          placement="right"-->
        <!--          width="400"-->
        <!--          trigger="click">-->
        <!--          <div>-->
        <!--            hello-->
        <!--          </div>-->
        <!--          <el-button slot="reference" style="width: 100%">Фильтра</el-button>-->
        <!--        </el-popover>-->
        <el-dialog
          title="Фильтры"
          :visible.sync="dialogVisible"
        >
          <div>
            <filter-select v-model="filter.status" @input="changeStatus" label="Статус наряда" :options="[
              {
              label: 'Показать все',
              value: null,
            },
              {
              label: 'Без статуса',
              value: '',
            },
              {
              label: 'В работе',
              value: 'IN_PROGRESS',
            },
            {
              label: 'Выполнено',
              value: 'IN_TEST',
            },
            {
              label: 'Принято',
              value: 'DONE',
            },
            {
              label: 'Просрочено',
              value: 'DEADLINE',
            }
            ]">
            </filter-select>
            <filter-select v-model="filter.executor" label="Исполнитель" :options="options.users">

            </filter-select>
            <filter-select v-model="filter.user" label="Создатель" :options="options.users">

            </filter-select>
            <filter-select v-model="filter.object" label="Объект" :options="options.objects">

            </filter-select>
            <filter-select v-model="filter.category" label="Категория" :options="options.categories">
            </filter-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Ок</el-button>
          </span>
        </el-dialog>
        <el-button slot="reference" style="width: 100%" @click="dialogVisible = true">Фильтры</el-button>
      </div>
      <div class="filter">
        <date-picker
          lang="ru"
          :editable="false"
          v-if="render"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="datetimeRange"
          @change="changeDateTime"
          range
        ></date-picker>

      </div>
      <a
        @click="openDialog = true"
        class="filter-btn"
      >
        <el-button type="default">Выгрузить</el-button>
      </a>
    </div>
    <div class="reports-ul">
      <router-link
        :to="`/dashboard/workorders-reports/create/${report.id}`"
        :key="report.id"
        class="reports-li" v-for="report in filteredReports"
      >
        <div class="header-id">
          <div style="display: flex; align-items: center">
            <span style="margin-right: 8px">#{{ report.index }}</span>
            <div class="progress-circle"
                 :style="{color: pStatus(report.totalPercent || 0), borderColor: pStatus(report.totalPercent || 0)}">
              {{ formatNumber(report.totalPercent) }}%
            </div>

            <div class="progress-circle"
                 v-if="$store.state.project.workorder.analytics === 'progress' "
                 :style="{color:  getProfColor(report), borderColor: getProfColor(report), marginLeft: '8px'}">
              {{ formatNumber(report.totalProfPercent || 0) }}%
            </div>
          </div>
          <span>{{ report.date }} - {{ report.end_date }}</span>
        </div>
        <span><strong>{{ report.title }}</strong></span>
        <span>Автор: <strong>{{ report.user.name }}</strong></span>
        <span>Назначено: <strong>{{ report.executor && report.executor.name }}</strong></span>
        <span>Категория: <strong>{{ report.category && report.category.name }}</strong></span>
        <span>Статус: <strong>{{ (report.status && report.status.label) || 'Без статуса' }}</strong></span>

      </router-link>
    </div>


    <el-dialog
      title="Выгрузить отчет"
      :visible.sync="openDialog"
      width="30%"
      center
    >
      <div v-if="!type_select" class="select-container">
        <div class="btn-container">
          <el-button style="width: 100%" type="default" @click="type_select = 'list'">Реестр нарядов</el-button>
        </div>
        <div class="btn-container">
          <el-button style="width: 100%" type="default" @click="type_select = 'progress'">Прогресс по нарядам
          </el-button>
        </div>
        <div class="btn-container">
          <el-button style="width: 100%" type="default" @click="type_select = 'production'">Производительность по
            нарядам
          </el-button>
        </div>
        <div class="btn-container">
          <el-button style="width: 100%" type="default" @click="type_select = 'journal'">Журнал отчетов</el-button>
        </div>

        <div class="btn-container">
          <el-button style="width: 100%" type="default" @click="type_select = 'price'">Стоимость по нарядам</el-button>
        </div>
      </div>
      <div v-else>
        <div>
          <div>
            <date-picker
              lang="ru"
              :editable="false"
              ref="datePicker"
              placeholder="Фильтр по дате"
              v-model="datetimeRangeDownload"
              range
            ></date-picker>
            <el-row>
              <el-col :span="12">
                <el-checkbox v-model="downloadForAll" style="margin-top: 10px">За все время</el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-if="type_select === 'progress'" v-model="checkbox.laborIntensity"
                             style="margin-top: 10px">Трудоемкость
                </el-checkbox>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-if="type_select === 'progress'" v-model="checkbox.price" style="margin-top: 10px">
                  Стоимость
                </el-checkbox>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-form v-if="type_select === 'progress' || type_select  === 'production'">
          <filter-select
            v-model="filterExcel.status"
            label="Статус наряда"
            multiple
            :options="statusOptions"
          />
        </el-form>

        <el-form v-if="type_select === 'price'">
          <filter-select :options="getAllInputOptions" label="Выберите поле" v-model="formExcel.details"/>
        </el-form>


        <span slot="footer" class="dialog-footer" style="padding-top: 24px; box-sizing: border-box; display: flex">
          <el-button @click="closeDialog" style="margin-right: 8px">Закрыть</el-button>
          <a :href="getHref" target="_blank" :class="{disabled: !getHref}">
            <el-button type="primary" @click="closeDialog" >Выгрузить</el-button>
          </a>
        </span>
      </div>
    </el-dialog>
  </el-form>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import _ from 'lodash';
import {apiUrl, isApiRuleIgnore} from '../../../plugins/firebase';
import {formatEndDate, formatStartDate} from "../../../utils/date";
import {getMyCompanyUsers, getPermission, getPermissionByUser} from "../../../firestore/permission";
import AddObject from "../Documentation/components/AddObject";
import FilterSelect from "../../../components/FilterSelect";
import {getUsersOptions} from "../../../firestore/users";
import {getObjectOptions} from "../../../firestore/objects";
import {getOptionsWorkorderCategories} from "../../../firestore/workorder-categories";
import {formatNumber, pStatus} from "../../../utils/numberUtils";
import {v4 as uuidv4} from "uuid";

export default {
  name: 'Index',
  components: {FilterSelect, AddObject, DatePicker},
  data() {
    return {
      openDialog: false,
      search: '',
      exelOptions: {
        dirs: [],
        details: []
      },
      role: 'admin',
      typeSelect: '',
      searchHead: '',
      user: null,
      userSelect: null,
      dialogVisible: false,
      init: false,
      render: true,
      checkbox: {
        laborIntensity: false,
        price: false
      },
      formExcel: {
        dir: {
          label: 'Все разделы',
          value: null
        },
        details: {
          label: 'Без выбора',
          value: null
        },
        job: [],
      },
      options: {
        users: [],
        objects: [],
        categories: [],
      },
      statusOptions: [{
        label: 'Без статуса',
        value: 'NONE',
      },
        {
          label: 'В работе',
          value: 'IN_PROGRESS',
        },
        {
          label: 'Выполнено',
          value: 'IN_TEST',
        },
        {
          label: 'Принято',
          value: 'DONE',
        },
        {
          label: 'Просрочено',
          value: 'DEADLINE',
        }],
      filterExcel: {
        status: null
      },
      filter: {
        object: '',
        executor: '',
        user: '',
        category: '',
        status: {
          label: "В работе",
          value: "IN_PROGRESS"
        },
      },
      type_select: null,
      datetimeRange: [
        null,
        null,
      ],
      downloadForAll: false,
      downloadWithPrice: false,
      datetimeRangeDownload: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      reports: [],
    };
  },

  async mounted() {

    const details = []
    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('inputs')
      .get()
      .then((data) => {
        data.forEach((subDoc) => {
          let _data = subDoc.data();
          details.push({
            ..._data,
            label: _data.name,
            value: subDoc.id || uuidv4(),
          })
        });

        this.exelOptions.details = details
      })


    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));

    if (!this.$store.state.project.version && !this.permission.usePermission) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id) || null);
    }

    const filters = localStorage.getItem('filters_' + this.$store.state.project.id);
    let query = {}

    await this.fetchUser()
    if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
      query.plan = this.$store.state.project.plan.id;
    }

    this.objects = await getObjectOptions(this.$store.state.project.id, this.permission, query);

    if (filters) {
      this.filter = JSON.parse(filters);
      if (!this.filter) {
        this.filter.status = {
          label: "В работе",
          value: "IN_PROGRESS"
        }
      }
      this.changeStatus();
    }

    setTimeout(() => this.init = true, 3000);


    if (this.$route.query.start) {
      this.datetimeRange = [
        new Date(String(this.$route.query.start)),
        new Date(String(this.$route.query.end)),
      ];
    } else if (this.$store.state.project.disableDate) {
      this.datetimeRange = [
        new Date(String(dayjs().subtract(365 * 5, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().add(365 * 5, 'days').format('YYYY-MM-DD'))),
      ];
    }

    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).get().then(async (sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[firebase.auth().currentUser.uid];
          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
      setTimeout(() => {
        this.fetchReports();
        this.fetchUsers();
        this.fetchCategories();
        this.fetchObjects();
      }, 200)
    });
  },

  watch: {
    '$route.query': {
      handler(response) {
        this.fetchReports();
      },
      deep: true,
    },
    type_select() {
      this.datetimeRangeDownload = [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ]
    }
  },

  methods: {
    getProfColor(form) {

      if(form.totalProfPercent) {
        return form.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }

      if (form.totalProfNorm === 0 && form.totalProfFact === 0) {
        return '#7CB342'
      } else if (form.totalProfNorm && !form.totalProfFact) {
        return '#7CB342'
      } else if (form.totalProfFact && !form.totalProfNorm) {
        return '#D32F2F'
      } else {
        return form.totalProfPercent <= 100 ? '#D32F2F' : '#7CB342'
      }
    },
    formatNumber,
    pStatus,
    searchTextInArray(searchStr, array) {
      const processedSearchStr = searchStr.replace(/\s+/g, '').toLowerCase();

      for (let i = 0; i < array.length; i++) {
        console.log(array[i], 'array[i]')
        if (array[i]) {
          const processedItem = array[i].replace(/\s+/g, '').toLowerCase();

          if (processedItem.includes(processedSearchStr)) {
            return true;
          }
        }
      }

      return false;
    },
    changeStatus() {
      if (this.filter.status.value === 'DEADLINE') {
        localStorage.setItem('datetimefilter', JSON.stringify(this.datetimeRange))
        setTimeout(() => {
          this.datetimeRange = [
            null,
            null,
          ]
          this.changeDateTime()
        });
      } else if (this.datetimeRange[0] === null) {
        const date = localStorage.getItem('datetimefilter');
        if (date) {
          this.datetimeRange = JSON.parse(date);
          this.datetimeRange = [
            new Date(this.datetimeRange[0]),
            new Date(this.datetimeRange[1]),
          ];
          setTimeout(() => {
            localStorage.removeItem('datetimefilter');
            this.changeDateTime()
          }, 200)
        }
      }
    },
    closeDialog() {
      setTimeout(() => {
        this.openDialog = false;
        this.type_select = null;
      }, 1000);
    },
    selectUser() {
      let query = {
        ...this.$route.query,
      };
      if (!this.userSelect) {
        delete query.user;
      } else {
        query = {
          ...this.$route.query,
          user: this.userSelect,
        };
      }

      this.$router.push({
        path: this.$route.path,
        query: {
          ...query,
        },
      });
    },
    fetchUser() {
      this.loading = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || firebase.auth().currentUser.uid)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const user = subDoc.data();
            if (user.name.length && user.position && user.position.length) {
              this.isCreatedUser = subDoc.id;
            }
            this.user = {
              ...user,
              name: user.name || firebase.auth().currentUser.email,
              user_profile_id: subDoc.id,
            };
          });

        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    async fetchUsers() {
      this.loader = true;

      this.options.users = await getUsersOptions(this.$store.state.project.id);
      this.loading = false;
    },
    async fetchCategories() {
      this.loader = true;

      this.options.categories = await getOptionsWorkorderCategories(this.$store.state.project.id);

      this.loading = false;
    },
    async fetchObjects() {
      this.loader = true;

      this.options.objects = await getObjectOptions(this.$store.state.project.id);

      this.loading = false;
    },
    changeDateTime() {
      if (this.datetimeRange[0] && this.datetimeRange[1]) {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            start: dayjs(this.datetimeRange[0]).format('YYYY-MM-DD'),
            end: dayjs(this.datetimeRange[1]).format('YYYY-MM-DD'),
          },
        });
      } else {
        const query = {...this.$route.query};
        delete query.start;
        delete query.end;
        this.$router.push({
          path: this.$route.path,
          query: {
            ...query
          },
        });
        this.fetchReports();
      }
    },
    sendReport() {
      const proxy = firebase.functions().httpsCallable(`onGenerateLogCommonJobs/${this.$store.state.project.id}`);
      proxy().then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отчет отправлен вам на почту',
          type: 'success',
        });
      }).catch(() => {
        this.$notify({
          offset: 60,

          title: 'Ошибка',
          message: 'Произошла ошибка, попробуйте позже',
          type: 'error',
        });
      });
    },
    navigate(report) {
      this.$router.push(
        `/dashboard/reports/edit/${report.id}/${this.$route.params.type}`,
      );
    },
    fetchReports: async function () {
      let query = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('workorders');


      const filterArray = [];

      if (this.search) {
        filterArray.push(
          ['index', '==', Number(this.search)],
        );
      }

      if (this.$route.query.start && this.$route.query.end) {
        filterArray.push(
          ['deadline_dateunix', '<', formatEndDate(this.$route.query.end)],
        );
        filterArray.push(
          ['deadline_dateunix', '>', formatStartDate(this.$route.query.start)],
        );
      } else if (this.datetimeRange[1] && this.datetimeRange[0]) {
        filterArray.push(
          ['deadline_dateunix', '<', formatEndDate(this.datetimeRange[1])],
        );
        filterArray.push(
          ['deadline_dateunix', '>', formatStartDate(this.datetimeRange[0])],
        );
      }

      query = filterArray.reduce((accQuery, filter) => {
        return accQuery.where(filter[0], filter[1], filter[2]);
      }, query).orderBy('deadline_dateunix', 'desc');


      query.get()
        .then(async (data) => {
          const result = [];
          this.reports = [];
          data.forEach((subDoc) => {
            const data = subDoc.data();


            let planId = data.planId;

            if (!planId) {
              try {
                planId = data.jobs[0].job.planID;
              } catch (e) {
                try {
                  planId = data.jobs[0][0].job.planID;
                } catch (e) {
                }
              }
            }


            if (this.$store.state.project.plan && this.$store.state.project.plan.id && planId !== this.$store.state.project.plan.id) {
              return
            }

            result.push({
              ...data,
              index: data.index,
              id: subDoc.id,
              object: data.object && data.object.name,
              objectId: data.object && data.object.id,
              date: dayjs(data.deadline_datetime).isValid() ? dayjs(data.deadline_datetime.substring(0, data.deadline_datetime.indexOf('+'))).format('DD/MM/YY') : '/',
              end_date: dayjs(data.deadline_datetime_end).isValid() ? dayjs((data.deadline_datetime_end || '').substring(0, (data.deadline_datetime_end || '').indexOf('+'))).format('DD/MM/YY') : '/',

              jobs: data.jobs,
            });
          });

          let final_result = [];
          // if (this.role === 'editor') {
          //   const usersIds = await getMyCompanyUsers(this.$store.state.project.id);
          //   console.log(result, 'AJFJJFASJSJJASFJFJ')
          //
          //   final_result = result.filter((r) => usersIds.includes(r.userId) || usersIds.includes(r.executor.id));
          // } else {
          final_result = result;
          // }

          this.reports = _.orderBy(final_result, 'index', ['asc']);

          // this.reports = _.orderBy(reports, 'deadline_dateunix', ['asc']);
        });
    },
  },
  computed: {
    getAllInputOptions() {
      return this.exelOptions.details.filter((detail) => detail.type && detail.type.value && (detail.type.value.includes('multiple') || detail.type.value.includes('constructions') || detail.type.value.includes('materials')))
    },
    filteredReports() {

      if (this.init) {
        localStorage.setItem('filters_' + this.$store.state.project.id, JSON.stringify(this.filter))
      }

      const reports = this.reports.filter((report) => {
        if (this.filter.status && this.filter.status.value && this.filter.status.value !== 'DEADLINE') {
          if ((report.status && report.status.value) !== this.filter.status.value) {
            return false;
          }
        }

        if (this.filter.status && this.filter.status.value === '') {
          if (report.status !== '') {
            return false;
          }
        }

        if (this.filter.status && this.filter.status.value === 'DEADLINE') {
          if ((report.status && report.status.value) === 'DONE' || (report.status && report.status.value) === 'IN_TEST') {
            return false
          }

          // if(report.status && (report.status.value === 'DONE' || report.status.value === 'IN_TEST')) {
          //   if(isNaN(report.finish_dateunix)) {
          //     return false
          //   }
          //
          //   if(dayjs(report.deadline_dateunix * 1000).add(1, 'days').unix() > report.finish_dateunix) {
          //     return false
          //   }
          //   return true
          // }

          if (dayjs(report.deadline_dateunix * 1000).add(1, 'days').unix() > dayjs().unix()) {
            return false
          }
        }

        const notifications = (report.notifications || []).map(({value}) => value)

        if (notifications.includes(firebase.auth().currentUser.uid)) {
          if (this.filter.object && this.filter.object.value) {
            const allObjects = report.inputObjects.map((obj) => {
              return obj.name
            })

            if (!this.searchTextInArray(this.filter.object.label, allObjects)) {
              return false
            }
          }

          if (this.filter.executor && this.filter.executor.value) {
            if (report.executor.id !== this.filter.executor.value) {
              return false;
            }
          }

          if (this.filter.user && this.filter.user.value) {
            if (report.userId !== this.filter.user.value && (report.user && report.user.id) !== this.filter.user.value) {
              return false;
            }
          }

          if (this.filter.category && this.filter.category.value) {
            if ((report.category && report.category.id) !== this.filter.category.value) {
              return false;
            }
          }


          if (this.search) {
            if (report.index != this.search) {
              return false
            }
          }


          if (this.searchHead) {
            return report.title.toLowerCase().includes(this.searchHead.toLowerCase())
          }

          return true

        }

        if (this.role === 'worker') {
          if (((report.executor || {}).id !== firebase.auth().currentUser.uid && report.userId !== firebase.auth().currentUser.uid)) {
            return false
          }
        }

        if (this.role === 'editor') {
          if ((report.executor && report.executor.name === this.user.company || report.executor && report.executor.name === this.user.name)
            || (report.user && report.user.company === this.user.company)
            || (report.reporter && report.reporter.company === this.user.company)
          ) {
          } else {
            return false
          }
        }

        if (this.filter.object && this.filter.object.value) {
          const allObjects = report.inputObjects.map((obj) => {
            return obj.name
          })

          if (!this.searchTextInArray(this.filter.object.label, allObjects)) {
            return false
          }
        }

        if (this.filter.executor && this.filter.executor.value) {
          if ((report.executor && report.executor.id) !== this.filter.executor.value) {
            return false;
          }
        }

        if (this.filter.user && this.filter.user.value) {
          if (report.userId !== this.filter.user.value && (report.user && report.user.uid) !== this.filter.user.value) {
            return false;
          }
        }

        if (this.filter.category && this.filter.category.value) {
          if ((report.category && report.category.id) !== this.filter.category.value) {
            return false;
          }
        }


        if (this.search) {
          if (report.index != this.search) {
            return false
          }
        }


        if (this.searchHead) {
          return report.title.toLowerCase().includes(this.searchHead.toLowerCase())
        }


        return true

      });

      return reports;
    },
    getHref() {
      const fromDate = dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')
      const toDate = dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')
      const project = this.$store.state.project.id;

      if (this.type_select === 'list') {
        const params = encodeURIComponent(`/onGenerateWorkOrders/${this.$store.state.project.id}`)
        let url = `${apiUrl}${params}&queryParams=uid=${this.$store.state.company.uid || this.$store.state.company.id || firebase.auth().currentUser.uid}`;

        if (this.downloadForAll) {
          url += `, isAllJobs=true`;
        } else {
          url += `, fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}, toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;
        }


        if (isApiRuleIgnore) {
          url = decodeURIComponent(url)
        }


        if (isApiRuleIgnore) {
          url = url.replace('&queryParams=', '?').replace(/, /g, "&")
        }

        return url
      }

      const uid = this.$store.state.company.uid || this.$store.state.company.id || firebase.auth().currentUser.uid

      let url = `${apiUrl}/onGenerateWorkOrdersProgressReportExcel%3FprojectId%3D${project}%26uid%3D${uid}`

      if (this.type_select === 'production') {
        url = `${apiUrl}/onGenerateWorkOrdersPerformanceReportExcel%3FprojectId%3D${project}%26uid%3D${uid}`
      }

      if (this.type_select === 'journal') {
        if (isApiRuleIgnore) {
          return decodeURIComponent(`${apiUrl}/onGenerateWorkOrderReportsJournalExcel%3FprojectId%3D${project}%26uid%3D${uid}`)
        }
        return `${apiUrl}/onGenerateWorkOrderReportsJournalExcel%3FprojectId%3D${project}%26uid%3D${uid}`
      }

      if (this.type_select === 'price') {
        let url = `${apiUrl}/onGenerateSalaryByWorkOrdersExcel%3FprojectId%3D${project}%26uid%3D${uid}`;

        if (this.downloadForAll) {
          url += `%26isAllJobs%3Dtrue`;
        } else {
          url += `%26fromDate%3D${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}%26toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;
        }


        if (!this.formExcel.details.value ) {
          return null
        }
        if (this.formExcel.details.value) {
          url += `%26inputId%3D${this.formExcel.details.value}`;
        }

        console.log(url, 'url')

        if (isApiRuleIgnore) {
          url = decodeURIComponent(url)
        }


        if (isApiRuleIgnore) {
          url = url.replace('&queryParams=', '?').replace(/, /g, "&")
        }

        return url
      }

      if (this.checkbox.price && this.type_select === 'progress') {
        url += `%26price%3Dtrue`
      }

      if (this.checkbox.laborIntensity && this.type_select === 'progress') {
        url += `%26laborIntensity%3Dtrue`
      }

      if (this.filterExcel.status && this.filterExcel.status.length) {
        const statuses = this.filterExcel.status.map(({value}) => {
          return value
        })
        url += `%26status%3D${statuses.join('%2C')}`
      }

      if (!this.downloadForAll) {
        url += `%26fromDate%3D${fromDate}%26toDate%3D${toDate}`
      }

      if (isApiRuleIgnore) {
        url = decodeURIComponent(url)
      }

      if (isApiRuleIgnore) {
        url = url.replace('&queryParams=', '?').replace(/, /g, "&")
      }

      return url
    },
  },
};
</script>

<style scoped lang="scss">
.btn-container {
  margin-bottom: 8px;
}

.progress-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: #13ce66;
  min-width: 28px;
  height: 28px;
  padding-left: 1px;
  padding-right: 1px;
  border-radius: 16px;
  border: 1px solid #13ce66;
}

.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.input-search {
  margin-top: 10px;
}

.reports-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  cursor: pointer;
  padding: 10px 14px;
  text-decoration: none;
  color: #000;
  @media screen and (max-width: 764px) {
    width: 92%;

  }

  .header-id {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    width: 100%;

    span:last-child {
      text-align: right !important;
    }
  }

  span {
    font-size: 14px;
    color: #2c3e50;
    text-align: left;
  }

  span:first-child {
    margin-right: 20px;
  }


  span {
    margin-right: 5px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

> > > .el-date-editor--daterange.el-input__inner {
  width: 100%;
  margin-top: 10px;
}

.add-block {
  button {
    width: 100%;
    margin-top: 10px;
  }
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 260px;

  .input-search {
    margin-right: 10px;
    min-width: 260px;
  }

  .filter-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
}

.create-new {
  display: flex;
  justify-content: flex-start;
  flex: 1;
}

.jobs-list {
  display: flex;
  flex-direction: column;
}

.text-search-container {
  display: flex;
  flex-direction: row !important;

  .number-search {
    min-width: 160px;
  }
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }


  .text-search-container {
    display: flex;
    flex-direction: row !important;

    .input-search {
      min-width: 55% !important;
    }

    .number-search {
      min-width: auto !important;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-select {
      width: 100%;
    }
  }
}

.create-new {
  display: flex;
  justify-content: space-between;
}

.filter {
  min-width: 260px;
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  margin-right: 5px;
}

.mx-datepicker-range {
  width: 100%;
  margin-top: 10px;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}
</style>
<style scoped lang="scss">
.disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/List.vue